import React from 'react';
import { FormattedMessage } from 'react-intl';
import { appNotification } from '../../containers/App/appNotification';
import { createLocalNotification } from '../../containers/App/utils';

const notification = createLocalNotification('ReservationPdf', {
    error: (
        <FormattedMessage
            id='front-app/ReservationPdf/Notification/Error:title'
            defaultMessage='Reservation Pdf Error'
        />
    ),
});

export const reservationPdfNotifications = {
    unknownError: (details?: JSX.Element | string) => (
        notification.error(appNotification.texts.unknownError(details))
    ),
};
